import LandscapeBlocker from './landscape-blocker';

export default LandscapeBlocker;
